import React, { useEffect, useState } from "react";
import { ITransmitente } from "..";
import theme from "../../../../Styles/theme";
import { ModalLoader } from "../../../ModalLoader";
import Modal from "react-modal";
import { Alert } from "../../../Error/Alert";
import { ModalDivX } from "../../../ModalDivX";
import { ContainertInput, Label, Container } from "./styles";
import { cpfMask } from "../../../../Services/cpfMask";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { validateCPF } from "../../../../Services/validateCPF";
import api from "../../../../Services/api";
import { useParams } from "react-router";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { cnpjMask } from "../../../../Services/cnpjMask";
import { isRural } from "../../../../Utils/isRural";

import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { useTransmitente } from "../../../../Storage/Transmitente";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
    padding: "1rem", // Reduzindo o padding
    zIndex: 999,
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  transmitente: ITransmitente;
  handleSetTransmitente(n_transmitente: ITransmitente): void;
  rural?: boolean;
}
export function ModalTransmitente({
  open,
  onClose,
  transmitente,
  handleSetTransmitente,
  rural,
}: Props) {
  const { cartorioIsLogged, cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const { getTransmitentes } = useTransmitente();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const [NOME, setNOME] = useState("");
  const [CPF_CNPJ, setCPF_CNPJ] = useState("");
  const [RUA, setRUA] = useState("");
  const [NUMERO, setNUMERO] = useState(0);
  const [COMPLEMENTO, setCOMPLEMENTO] = useState("");
  const [MUNICIPIO, setMUNICIPIO] = useState("");
  const [UF, setUF] = useState("");
  const [BAIRRO, setBAIRRO] = useState("");
 

  const { id } = useParams();

  useEffect(() => {
    if (transmitente.ID) {
      setNOME(transmitente.NOME);
      setCPF_CNPJ(
        transmitente.CPF
          ? cpfMask(transmitente.CPF)
          : cnpjMask(transmitente.CNPJ)
      );
      setRUA(transmitente.RUA);
      setNUMERO(transmitente.NUMERO);
      setCOMPLEMENTO(transmitente.COMPLEMENTO);
      setUF(transmitente.UF);
      setBAIRRO(transmitente.BAIRRO);
      setMUNICIPIO(transmitente.MUNICIPIO);
    } else {
      setNOME("");
      setCPF_CNPJ("");
      setRUA("");
      setNUMERO(0);
      setCOMPLEMENTO("");
      setUF("");
      setBAIRRO("");
      setMUNICIPIO("");
    }
  }, [open]);

  function validateForm() {
    if (limpa_cpf_cnpj(CPF_CNPJ).trim().length === 14) {
      if (!validateCNPJ(limpa_cpf_cnpj(CPF_CNPJ))) {
        setError({
          message: "O CNPJ digitado é inválido!",
          title: "CNPJ Inválido",
        });
        return false;
      }
    } else {
      if (!validateCPF(limpa_cpf_cnpj(CPF_CNPJ))) {
        setError({
          message: "O CPF digitado é inválido!",
          title: "CPF Inválido",
        });
        return false;
      }
    }

    if (NOME.trim().length === 0) {
      setError({
        message: "O nome digitado é inválido!",
        title: "TRANSMITENTE Inválido",
      });
      return false;
    }

    if (BAIRRO.trim().length === 0) {
      setError({
        message: "O BAIRRO digitado é inválido!",
        title: "BAIRRO Inválido",
      });
      return false;
    }
    if (RUA.trim().length === 0) {
      setError({
        message: "A RUA digitada é inválida!",
        title: "RUA Inválida",
      });
      return false;
    }
    if (NUMERO <= 0) {
      setError({
        message: "O NUMERO digitado é inválido!",
        title: "NUMERO Inválido",
      });
      return false;
    }

    if (MUNICIPIO.trim().length === 0) {
      setError({
        message: "O MUNICIPIO digitado é inválido!",
        title: "MUNICIPIO Inválido",
      });
      return false;
    }

    if (UF.trim().length === 0) {
      setError({
        message: "A Unidade Federativa digitada é inválida!",
        title: "Unidade Federativa Inválida",
      });
      return false;
    }
    return true;
  }

  async function buscarUltimoRegistro() {
    try {
      setLoading(true);
      const { data } = await api.post(
        `/adquirinte-transmitente/${cartorio.ID}`,
        { cpf_cnpj: limpa_cpf_cnpj(CPF_CNPJ) }
      );
      setNOME(data[0].NOME);
      setRUA(data[0].RUA);
      setBAIRRO(data[0].BAIRRO);
      setCOMPLEMENTO(data[0].COMPLEMENTO);
      setMUNICIPIO(data[0].MUNICIPIO);
      setNUMERO(data[0].NUMERO);
      setNOME(data[0].NOME);
      setNOME(data[0].NOME);
      setUF(data[0].UF);
    } catch (error) {
      setError({
        title: "Ops",
        message: "Nenhum registro encontrado com esta chave!",
      });
    } finally {
      setLoading(false);
    }
  }

  async function post() {
    if (validateForm())
      try {
        if (cartorioIsLogged) {
          await checarToken();
        }

        if (funcionarioCartorioIsLogged) {
          await checarTokenFuncionario();
        }

        setLoading(true);
        if (transmitente.ID) {
          const cpf =
            limpa_cpf_cnpj(CPF_CNPJ).length === 11
              ? limpa_cpf_cnpj(CPF_CNPJ)
              : null;
          const cnpj =
            limpa_cpf_cnpj(CPF_CNPJ).length === 14
              ? limpa_cpf_cnpj(CPF_CNPJ)
              : null;

          const { data } = await api.put(`/transmitente`, {
            NOME,
            RUA,
            NUMERO,
            COMPLEMENTO,
            IMOVEL_ID: isRural() ? null : id,
            IMOVEL_RURAL_ID: isRural() ? id : null,
            CPF: cpf,
            CNPJ: cnpj,
            MUNICIPIO,
            BAIRRO,
            UF,
            ID: transmitente.ID,
          });

          handleSetTransmitente(data);
        } else {
          const cpf =
            limpa_cpf_cnpj(CPF_CNPJ).length === 11
              ? limpa_cpf_cnpj(CPF_CNPJ)
              : null;
          const cnpj =
            limpa_cpf_cnpj(CPF_CNPJ).length === 14
              ? limpa_cpf_cnpj(CPF_CNPJ)
              : null;

          const { data } = await api.post(`/transmitente`, {
            NOME,
            RUA,
            NUMERO,
            COMPLEMENTO,
            IMOVEL_ID: isRural() ? null : id,
            IMOVEL_RURAL_ID: isRural() ? id : null,
            CPF: cpf,
            CNPJ: cnpj,
            MUNICIPIO,
            BAIRRO,
            UF,
          });

          handleSetTransmitente(data);
        }
        onClose();
      } catch (error) {
        setError({
          title: "Não foi salvar as alterações!",
          message: "Não foi possível salvar as alterações do transmitente!",
        });
      } finally {
        setLoading(false);
        getTransmitentes();
      }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="TRANSMITENTE"
            variant="outlined"
            fullWidth
            value={NOME}
            onChange={(ev) => setNOME(ev.target.value)}
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginRight: "10px",
            }}
          />
          <TextField
            label="CPF | CNPJ"
            variant="outlined"
            fullWidth
            value={CPF_CNPJ}
            onChange={(ev) => {
              let teste = "";
             
              if (ev.target.value.length <= 14) {
                teste = cpfMask(ev.target.value);
              } else {
                teste = cnpjMask(ev.target.value);
              }
              setCPF_CNPJ(teste);
            }}
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginLeft: "10px",
            }}
          />
        </div>
  
          <>
            <Button
              variant="contained"
              style={{ marginTop: "8px", width: "100%" }}
              // hidden={}
              onClick={() => {
                buscarUltimoRegistro();
              }}
            >
              BUSCAR
            </Button>
            <br />
            <br />
          </>
      

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="BAIRRO"
            variant="outlined"
            fullWidth
            value={BAIRRO}
            onChange={(ev) => setBAIRRO(ev.target.value)}
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginRight: "10px",
            }}
          />
          <TextField
            label="RUA"
            variant="outlined"
            fullWidth
            value={RUA}
            onChange={(ev) => setRUA(ev.target.value)}
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginLeft: "10px",
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="NÚMERO"
            variant="outlined"
            fullWidth
            value={NUMERO}
            onChange={(ev) =>
              setNUMERO(Number(ev.target.value.replace(/\D/g, "")))
            }
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginRight: "10px",
            }}
          />
          <TextField
            label="Complemento"
            variant="outlined"
            fullWidth
            value={COMPLEMENTO}
            onChange={(ev) => setCOMPLEMENTO(ev.target.value)}
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginLeft: "10px",
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="MUNICÍPIO"
            variant="outlined"
            fullWidth
            value={MUNICIPIO}
            onChange={(ev) => setMUNICIPIO(ev.target.value)}
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginRight: "10px",
            }}
          />
          <TextField
            label="UF"
            variant="outlined"
            fullWidth
            value={UF}
            onChange={(ev) => {
              let valor = ev.target.value.replaceAll(" ", "");
              if (valor.length <= 2) {
                setUF(valor);
              }
            }}
            style={{
              width: "calc(50% - 5px)",
              marginBottom: "10px",
              marginLeft: "10px",
            }}
          />
        </div>
        <Button
          variant="contained"
          onClick={() => post()}
          style={{ marginTop: "8px", width: "100%" }}
        >
          CONFIRMAR
        </Button>
      </Container>

      <ModalLoader loading={loading} />

      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </Modal>
  );
}
